// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './mailing-modal';
export * from './mailing-types';
export * from './mailing.module';
export * from './providers';
export * from './send-mail.directive';
export * from './services';
// @endindex